// extracted by mini-css-extract-plugin
module.exports = {"noJs":"scaffold_noJs__xJ1Cn"};